import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "./Siderbar";
import Topbar from "./Topbar";
import Footer from "./Footer";

const AdminProductEdit = () => {
  const { pid } = useParams(); // Get the product ID from the URL
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const [product, setProduct] = useState({
    pid: "",
    pname: "",
    image: "",
    min_qty: "",
    price: "",
    size: "",
    type: "",
    side: "",
    corner: "",
    lamination: "",
    cover: "",
    page_layout: "",
    sticker_size: "",
    inner_paper: "",
    pages: "",
  });

  const [imagePreview, setImagePreview] = useState(""); // Image preview for the current image

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await axios.get(`${baseURL}/fetch-product-inndus/${pid}`);
        
        setProduct(response.data.product); // Assuming response contains { product: {...} }
        setImagePreview(`${baseURL}/images/${response.data.product.image}`); // Set the image preview
      } catch (err) {
        console.error("Error fetching product details:", err);
      }
    };

    fetchProductDetails();
  }, [baseURL, pid]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProduct({ ...product, [name]: value });
    
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setProduct({ ...product, image: file }); // Update image file state
    setImagePreview(URL.createObjectURL(file)); // Preview the new image
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    // Append all form data
    Object.keys(product).forEach((key) => {
      // If the image is still the same, use the previous image URL.
      if (key === "image" && !product.image) {
        formData.append(key, product.image); // Add the existing image (if no new image)
      } else {
        formData.append(key, product[key]);
      }
    });

    try {
      const response = await axios.put(`${baseURL}/update-product-inndus/${pid}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // Handle success, e.g., show a success message or redirect
      navigate(`/fetch_admin_product`); // Redirect to the product list page after update
    } catch (err) {
      console.error("Error updating product:", err);
    }
  };

  return (
    <>
      <div className="d-flex">
        <Sidebar />
        <div className="flex-grow-1 d-flex flex-column" style={{ minHeight: "100vh" }}>
          <Topbar />
          <div className="flex-grow-1 p-4"></div>
          <div className="container">
            <h1 className="text-center">Edit Product</h1>
            <form onSubmit={handleSubmit}>
              {/* Product Name */}
              <div className="mb-3">
                <label htmlFor="pname" className="form-label">Product Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="pname"
                  name="pname"
                  value={product.pname}
                  onChange={handleInputChange}
                />
              </div>

              {/* Image Preview & File Input */}
              <div className="mb-3">
                <label htmlFor="image" className="form-label">Image</label>
                {imagePreview && <img src={imagePreview} alt="Product" style={{ width: '20%', padding: '20px' }} />}
                <input
                  type="file"
                  className="form-control"
                  id="image"
                  name="image"
                
                  onChange={handleFileChange}
                />
              </div>

              {/* <div className="mb-3">
        <label className="form-label">Use as template</label>
        <select
          name="main"
          onChange={handleFileChange}
          className="form-control"
          
        >
          <option value="" disabled>
            -- Select Category --
          </option>
          <option value="1">Stationery</option>
          <option value="2">Gifts</option>
          <option value="3">Marketing Collaterals</option>
          <option value="4">Packaging</option>
          <option value="5">Personalise Products</option>
        </select>
      </div> */}

              {/* Min Quantity */}
              <div className="mb-3">
                <label className="form-label">Min Quantity</label>
                <input
                  type="text"
                  name="min_qty"
                  value={product.min_qty}
                  onChange={handleInputChange}
                  className="form-control"
                  required
                />
              </div>

              {/* Price */}
              <div className="mb-3">
                <label className="form-label">Price</label>
                <input
                  type="text"
                  name="price"
                  value={product.price}
                  onChange={handleInputChange}
                  className="form-control"
                  required
                />
              </div>

              {/* Other fields (Textarea for JSON-like data) */}
              {[
                "size",
                "type",
                "side",
                "corner",
                "lamination",
                "cover",
                "page_layout",
                "sticker_size",
                "inner_paper",
                "pages",
              ].map((field) => (
                <div key={field} className="mb-3">
                  <label className="form-label">
                    {field.replace("_", " ").toUpperCase()}
                  </label>
                  <textarea
                    name={field}
                    className="form-control"
                    value={product[field]}
                    onChange={handleInputChange}
                    placeholder="Enter comma-separated values (e.g., value1, value2)"
                  />
                </div>
              ))}

              <button type="submit" className="btn btn-primary">Update</button>
            </form>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default AdminProductEdit;
